import { useRouter } from 'next/router'
import { useMemo } from 'react'

export const useCanonicalUrl = (pathToUse?: string) => {
  const { query, locale, defaultLocale, pathname } = useRouter()
  const { typeOrDistance, location, month } = query
  const currentPath = useMemo(() => {
    const baseUrl = `${process.env.APP_URI}${
      locale === defaultLocale ? '' : `/${locale}`
    }`
    if (pathToUse) {
      return `${baseUrl}${pathToUse}`
    }
    const pathSegments = [typeOrDistance, location, month].filter(Boolean)
    const path =
      pathSegments.length > 0
        ? `/${pathSegments.join('/')}`
        : locale?.toLowerCase() === defaultLocale?.toLowerCase()
        ? '/'
        : ''
    return `${baseUrl}${path}`
  }, [
    locale,
    defaultLocale,
    pathname,
    pathToUse,
    typeOrDistance,
    location,
    month
  ])

  const hasPage = !!query.page

  const canonicalUrl = useMemo(
    () =>
      pathToUse
        ? `${currentPath}`
        : currentPath + (hasPage ? `?page=${query.page}` : ''),
    [query]
  )

  return {
    currentPath,
    canonicalUrl
  }
}
